<template>
  <!-- 账号管理 -->
  <div>
    <el-card class="box-card box-cards" shadow="never">
      <el-row>
        <el-form :inline="true" class="user-search">
          <el-col :span="24">
            <el-form-item>
              <div class="card_top"><span>打卡积分设置</span></div>
            </el-form-item>

          </el-col>
        </el-form>
      </el-row>
    </el-card>
    <el-card class="box-card box-cards2" shadow="never">
      <div class="demo-drawer__content">
        <el-row :gutter="20">
          <el-form label-width="110px" :model="editForm" ref="editForm">

            <el-col :span="10" :offset="6">
              <div class="grid-content bg-purple">
                <el-form-item label="每日打卡基础积分：" prop="checkInBasePoints" label-width="200px">
                  <el-input v-model="editForm.checkInBasePoints"></el-input>
                </el-form-item>
                <el-form-item label="连续打卡额外积分：" prop="checkInStreakPoints" label-width="200px">
                  <el-input v-model="editForm.checkInStreakPoints"></el-input>
                </el-form-item>
                <el-form-item label="每日积分上限：" prop="dailyPointsLimit" label-width="200px">
                  <el-input v-model="editForm.dailyPointsLimit"></el-input>
                </el-form-item>
                <el-form-item label="学习时长积分系数：" prop="durationPointsRate" label-width="200px">
                  <el-input v-model="editForm.durationPointsRate"></el-input>
                </el-form-item>
                <el-form-item label="最大连续打卡天数：" prop="maxStreakDays" label-width="200px">
                  <el-input v-model="editForm.maxStreakDays"></el-input>
                </el-form-item>
                <el-form-item label="单词学习积分系数：" prop="wordPointsRate" label-width="200px">
                  <el-input v-model="editForm.wordPointsRate"></el-input>
                </el-form-item>
                <el-form-item label="兑换闪过侠玩偶所需积分:" prop="dollPointsRequired" label-width="200px">
                  <el-input v-model="editForm.dollPointsRequired"></el-input>
                </el-form-item>
                <el-form-item label="兑换闪过侠挂件所需积分：" prop="pendantPointsRequired" label-width="200px">
                  <el-input v-model="editForm.pendantPointsRequired"></el-input>
                </el-form-item>
                <el-form-item label="是否启用手机验证码登录" prop="phoneLogin" label-width="200px">
                  <el-switch v-model="editForm.phoneLogin" active-text="启用" inactive-text="不启用">
                  </el-switch>
                </el-form-item>
                <el-form-item label="开屏页是否跳过登录" prop="canSkipLogin" label-width="200px">
                  <el-switch v-model="editForm.canSkipLogin" active-text="跳过" inactive-text="不跳过">
                  </el-switch>
                </el-form-item>
                <el-form-item label-width="200px">
                  <el-button size="small" type="goon" class="title" @click="submitForm('editForm')">
                    保存</el-button>
                </el-form-item>
              </div>
            </el-col>
          </el-form>
        </el-row>

        <div style="height: 60px; margin-top: 50px"></div>
      </div>

    </el-card>


  </div>
</template>
<script>
import { configget, configupdate } from "../../api/userMG";
export default {
  data() {
    return {
      formInline: {
        data: {},
        params: {},
      },
      editForm: {}

    };
  },
  created() {
    this.getlist(this.formInline);
  },
  methods: {
    getlist(parameter) {
      configget(parameter).then((res) => {
        console.log("userlist", res);
        if (res.code != 200) {
          this.$message({
            type: "info",
            message: res.message,
          });
        } else {
          this.editForm = res.data
          // console.log(this.tableData)
        }
      })
        .catch((err) => {
        });
    },

    submitForm(info) {
      var data = JSON.parse(JSON.stringify(this.editForm))
      data.canSkipLogin = data.canSkipLogin ? 1 : 0
      data.phoneLogin = data.phoneLogin ? 1 : 0
      configupdate({
        data: {},
        params: data,
      })
        .then(res => {
          if (res.code == 200) {
            this.$message({
              message: "保存成功！",
              type: "success",
            });
          } else {
            this.$message({
              type: "info",
              message: res.message,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.$message.error("保存失败，请稍后再试！");
        });
    }

  },
};
</script>
<style>
@import "../../assets/css/index.css";

.title {}
</style>


// WEBPACK FOOTER //
// src/views/system/config.vue